import './App.css';
import {useState} from "react"
import { BrowserRouter as Router, Route, Routes, useNavigate } from "react-router-dom";
import CardPaymentPage from './components/cardPaymentPage';
import PaymentSuccessPage from './components/paymentSuccessPage';
import PaymentFailurePage from './components/paymentFailurePage';
import Pickles from './components/pickles';
import Preloader from './components/preloader';
import CartPage from './components/cartPage';
import Spices from './components/spices';
import Rice from './components/rice';
import AnimalFeed from './components/animalFeed';
import OtherProducts from './components/otherProducts';

function App() {
  const [cart, setCart] = useState([]);

  const navigate = useNavigate();

  const addToCart = (product) => {
    setCart((prevCart) => [...prevCart, product]);
    alert(`${product.name} added to cart!`);
    navigate("/cart");
  };

  console.log("cart",cart)
  return (
    <>
      <Preloader />
      <Routes>
        <Route path="/" element={<Pickles cart={cart} addToCart={addToCart}/>} />
        <Route path="/spices" element={<Spices cart={cart} addToCart={addToCart}/>} />
        <Route path="/rice" element={<Rice cart={cart} addToCart={addToCart}/>}/>
        <Route path="/animalfeed" element={<AnimalFeed cart={cart} addToCart={addToCart}/>}/>
        <Route path="/otherproducts" element={<OtherProducts cart={cart} addToCart={addToCart}/>}/>
        <Route path="/cart" element={<CartPage cart={cart} setCart={setCart} />} />
        <Route path="/cardPayment" element={<CardPaymentPage />} />
        <Route path="/success" element={<PaymentSuccessPage />} />
        <Route path="/failure" element={<PaymentFailurePage />} />
      </Routes>
    </>
  );
}


export default App;
